<template>
  <div v-if="!isAuthenticated">
    <v-row class="printing-action">
      <br>
      <naj-alert
        v-if="formModel.authenticated!=null"
        type="information"
      >
        <template slot="content">
          <span
            v-if="formModel.authenticated==partiesAuthenticationEnum.acceptAuthentication"
            class="bold"
          >
            {{ local.lawsuitRequest.authentication.acceptAuthentication }}</span>
          <span
            v-if="formModel.authenticated==partiesAuthenticationEnum.refusedAuthentication"
            class="bold"
          >{{ local.lawsuitRequest.authentication.refusedAuthentication }}</span>
          <span
            v-if="formModel.authenticated==partiesAuthenticationEnum.editAuthenticationData"
            class="bold"
          >{{ local.lawsuitRequest.authentication.editAuthenticationData }}</span>
        </template>
      </naj-alert>
    </v-row>

    <v-form ref="authenticationForm">
      <v-row>
        <v-col cols="10">
          <naj-input
            :type-id="formFieldType.radioButton"
            :label="local.lawsuitRequest.authentication.toAuthenticatedOnLawsuitRequestMustBeChoice"
            :value.sync="formModel.authenticated"
            :items="filteredAuthenticationOptions"
            item-text="name"
            item-value="id"
          ></naj-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="formModel.authenticated==partiesAuthenticationEnum.editAuthenticationData"
          cols="10"
        >
          <naj-input
            :type-id="formFieldType.textarea"
            :label="local.lawsuitRequest.authentication.beneficiaryNote"
            :value.sync="formModel.authenticationNote"
            validates="required|max:200"
          ></naj-input>
        </v-col>
        <v-col cols="2">
          <naj-button
            :disabled="formModel.authenticated == null || loading"
            :loading="loading"
            @click="submit"
          >
            {{ local.common.authentication }}
          </naj-button>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { partiesAuthenticationEnum, caseTypeEnum } from '@/helpers/enum';
const { mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');

export default {
  props: {
    caseTypeId: {
      required: true,
      validator: function (value) {
        return value !== undefined && value !== null;
      },
    },
    requestObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isAuthenticated: false,
      formModel: {},
      loading: false,
      showEvaluationModal: false,
      partiesAuthenticationEnum,
      caseTypeEnum,
    };
  },
  computed: {
    ...mapLUTState(['partiesAuthenticationOptions']),
    filteredAuthenticationOptions() {
      const options = this.partiesAuthenticationOptions;
      // if case type is privateRightArisingFromMedicalError (10400)
      // filter out option with id 2
      if (this.caseTypeId !== caseTypeEnum.privateRightArisingFromMedicalError) {
        return options.filter(option => option.id !== 2);
      }

      return options;
    },
  },
  methods: {
    ...mapActions(['updatePartyAuthentication']),
    submit() {
      if (this.$refs.authenticationForm)
        this.$refs.authenticationForm.$validator.validateAll().then((valid) => {
          if (valid) {
            this.loading = true;
            this.updatePartyAuthentication({
              ...this.formModel,
              objectKey: this.requestObjectKey,
            })
              .then(() => {
                this.isAuthenticated = true;
                this.toaster.success(this.local.lawsuitRequest.authentication.authenticationAcceptanceSuccessfully);
                this.showEvaluationModal = true;
              })
              .catch((err) => { this.toaster.error((err || {}).message); })
              .finally(() => {
                this.formModel.authenticated = null;
                this.loading = false;
              });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-action {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 2px dashed #000;
}
</style>